'use client';

import { useI18n } from '~/locales/client';
import { EMAIL_SALES } from '~/constants';
import Button from '~/components/customComponents/buttons/Button';
import Link from 'next/link';
import Modal from '~/components/customComponents/modal/Modal';
import Flex from '~/components/customComponents/flex/Flex';
import Text from '~/components/customComponents/texts/Text';

type DeactivatedModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DeactivatedModal = ({ isOpen, onClose }: DeactivatedModalProps) => {
  const translate = useI18n();

  if (!isOpen) return null;

  // Memoize translations to avoid re-computation on re-renders
  const titleLabel = translate('deactivated.modal.title');
  const introLabel = translate('deactivated.modal.intro');
  const bodyLabel = translate('deactivated.modal.body', {
    link: (
      <Link className="font-bold hover:underline" href={`mailto:${EMAIL_SALES}`}>
        {EMAIL_SALES}
      </Link>
    ),
  });
  const buttonLabel = translate('deactivated.modal.button');

  return (
    <Modal isOpen={isOpen} closeModal={onClose} size="sm" modalClassname="p-6">
      <Text variant="h3" className="text-center pb-2">
        {titleLabel}
      </Text>
      <Text className="text-center pb-2">{introLabel}</Text>
      <Text className="text-center">{bodyLabel}</Text>
      <Flex className="justify-center pt-4">
        <Button
          onClick={onClose}
          text={buttonLabel}
          buttonClassName="w-fit px-6 hover:bg-red-700"
        />
      </Flex>
    </Modal>
  );
};

export default DeactivatedModal;
